import clsx from 'clsx';
import React from 'react';
import { useNavigate } from 'react-router-dom';

export type BreadcrumbItem = {
  label: string;
  path?: string; // If provided, item is clickable and navigates to this path
  onClick?: () => void; // Alternative to path - custom click handler
};

type BreadcrumbProps = {
  items: BreadcrumbItem[];
  className?: string;
};

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, className = '' }) => {
  const navigate = useNavigate();

  const handleItemClick = (item: BreadcrumbItem) => {
    if (item.path) {
      navigate(item.path);
    } else if (item.onClick) {
      item.onClick();
    }
  };

  return (
    <div className={clsx('pb-4', className)}>
      <div>
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          const isClickable = item.path || item.onClick;

          return (
            <React.Fragment key={index}>
              {index > 0 && <span className="text-black text-base font-medium break-words"> &gt; </span>}
              <span
                className={clsx(
                  'text-base font-medium break-words',
                  isLast ? 'text-black' : 'text-[#B2B2B2]',
                  !isLast && isClickable && 'cursor-pointer hover:text-[#113D7B] transition-colors'
                )}
                onClick={isClickable ? () => handleItemClick(item) : undefined}
              >
                {item.label}
              </span>
            </React.Fragment>
          );
        })}
      </div>
    </div>
  );
};
